// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"117":"d150e1fd","137":"2e58a718","257":"df321a91","265":"73669f0e","323":"c78464eb","415":"b6b18c47","481":"93004194","538":"34e09d37","649":"06ff77ff","711":"9718ea0a","914":"b1fa5463","932":"36874586","944":"d4907f31","957":"52e4d19f","978":"e8bb46bd"}[chunkId] + ".js";
};